import '@/assets/js/bytetrade';
import { getPrivateKey } from '@/service';
import axios from '@/service/interceptor';
import settings from './settings';
import { ConstantUtil } from './ConstantUtil';
import {
    BigNumber,
} from 'bignumber.js';
import Config from './Config';
import Utils from './Utils';

function getOrderList(c, u, o = 0, m = '', l = 10, s, d) {
    const pm = new Promise((resolve, reject) => {
        const qsData = {
            cmd: settings.cmd[c],
            startTime: s,
            endTime: d,
            userid: u,
            market: m,
            limit: l,
            offset: o,
        };
        axios.post(`${settings.SERVER_PREFIX}/me`, qsData).then((res) => {
            if (res.data.code === 0) {
                resolve(res.data);
            } else {
                reject(res.data);
            }
        });
    });
    return pm;
}

function createOrders(ob, method, pk, account, address) {
    const pm = new Promise((resolve) => {
        const tr = new window.bytetrade_js.TransactionBuilder();
        tr.validate_type = 0;
        tr.dapp = Utils.getDapp(account.userid);
        tr.add_type_operation('order_create3', ob);
        tr.timestamp = Math.ceil(Date.now() / 1000);
        let privateKey = '';
        privateKey = getPrivateKey(account, pk);
        if (privateKey.toPublicKey().toAddressString() !== address) {
            resolve({ code: 402, errmsg: 'account_password_error' });
        }
        tr.add_signer(privateKey);
        tr.finalize().then(() => {
            if (!tr.signed) {
                tr.sign();
            }
            const trObject = tr.toObject();
            const newParams = {
                cmd: 'putTransaction',
                id: tr.id_int(),
                method,
                trObject: JSON.stringify(trObject),
            };
            axios.post(`${settings.SERVER_PREFIX}/me`, newParams).then((res) => {
                if (res.data.code === 0) {
                    resolve(res.data);
                } else {
                    resolve({ code: 403, errmsg: 'account_fail_transfer' });
                }
            });
        });
    });
    return pm;
}

function cancelOrders(accountInfo, userId, orderInfo, pwd) {
    const pm = new Promise((resolve, reject) => {
        const postData = {
            cmd: settings.cmd.listAccounts,
            userid: userId,
        };
        axios.post(`${settings.SERVER_PREFIX}/me`, postData).then((res) => {
            if (res && res.data && res.data.balances) {
                if (parseFloat(res.data.balances[0].available < 0.0009)) {
                    reject('BttIsNotEnough');
                }
                const ob = {
                    fee: ConstantUtil.Number.PackageFee * (10 ** settings.getBasePrecision('1')),
                    creator: accountInfo.userid,
                    order_id: orderInfo.orderid,
                    money_id: BigNumber(orderInfo.marketId).idiv(2147483647).toNumber(),
                    stock_id: BigNumber(orderInfo.marketId).mod(2147483647).toNumber(),
                    market_name: orderInfo.market,
                };
                const method = 'blockchain.put_transaction';
                const tr = new window.bytetrade_js.TransactionBuilder();
                tr.validate_type = 0;
                tr.dapp = Utils.getDapp(userId);
                tr.add_type_operation('order_cancel2', ob);
                tr.timestamp = Math.ceil(Date.now() / 1000);
                const privateKey = getPrivateKey(accountInfo, pwd);
                if (privateKey.toPublicKey().toAddressString() !== accountInfo.address) {
                    reject('Wrongpassword');
                }
                tr.add_signer(privateKey);
                tr.finalize().then(() => {
                    if (!tr.signed) {
                        tr.sign();
                    }
                    const trObject = tr.toObject();
                    const newParams = {
                        cmd: 'putTransaction',
                        id: tr.id_int(),
                        method,
                        trObject: JSON.stringify(trObject),
                    };
                    axios.post(`${settings.SERVER_PREFIX}/me`, newParams).then((resp) => {
                        if (resp.data.code === 0) {
                            resolve({ code: 0, msg: 'success' });
                        }
                    });
                });
            }
        });
    });
    return pm;
}

function buyOrder(pk, self) {
    let orderType = 0;
    if (self.selectedTab === 'marketOrder') {
        orderType = 2;
    } else {
        orderType = 1;
    }
    const amountSymbol = self.selectedTab === 'marketOrder' ? self.moneyId : self.stockId;
    const amount = self.getMinAmount(
        self.buyAmountValue,
        settings.getBasePrec(amountSymbol),
        10 ** self.amountPrec,
    );
    const price = self.getMinAmount(
        self.buyPriceValue,
        settings.getBasePrec(self.moneyId),
        10 ** self.pricePrec,
    );
    // ttt 0.00000001 1000000000000 100000000
    // 区块链newOrder
    const isBTTFee = self.isBttFee(2);
    const fee = 0;
    const userId = self.centerTrade ?
        self.$store.state.bttUserid :
        self.$store.getters.currAddress;
    const ob = {
        fee: ConstantUtil.Number.PackageFee * (10 ** settings.getBasePrecision('1')),
        creator: userId,
        side: 2,
        money_id: parseInt(self.moneyId),
        stock_id: parseInt(self.stockId),
        custom_no_btt_fee_rate: Config.custom_no_btt_fee_rate,
        // custom_btt_fee_rate: 10,
        order_type: orderType,
        market_name: self.selectedMarket,
        amount: amount.toFixed(0),
        price: self.selectedTab === 'marketOrder' ?
            0 : price.toFixed(0),
        now: Math.ceil(Date.now() / 1000),
        expiration: Math.ceil(Date.now() / 1000) + 10,
        use_btt_as_fee: isBTTFee,
        freeze_btt_fee: isBTTFee ? fee.toPrecision().toString() : 0,
    };
    const currindex = self.$store.state.currAccountIndex;
    const accountInfo = self.$store.state.accountList[currindex];
    const method = 'blockchain.put_transaction';
    return createOrders(
        ob,
        method,
        pk,
        accountInfo,
        self.$store.getters.currAccount.address,
    ).then((res) => {
        if (res.code !== 0) {
            return self.$Message.error(self.$t(res.errmsg));
        }
        return self.$Message.success(self.$t('trade_order_submitted'));
    });
}

function sellOrder(pk, self) {
    let orderType = 0;
    if (self.selectedTab === 'marketOrder') {
        orderType = 2;
    } else {
        orderType = 1;
    }

    const isBTTFee = self.isBttFee(1);
    const amount = self.getMinAmount(
        self.sellAmountValue,
        settings.getBasePrec(self.stockId),
        10 ** self.pricePrec,
    );
    const price = self.getMinAmount(
        self.sellPriceValue,
        settings.getBasePrec(self.moneyId),
        10 ** self.amountPrec,
    );
    // 区块链newOrder
    const useBttAsFee = self.moneyName === 'BTT' ? false : isBTTFee;
    const fee = 0;
    const userId = self.centerTrade ?
        self.$store.state.bttUserid :
        self.$store.getters.currAddress;
    // 区块链newOrder
    const ob = {
        fee: ConstantUtil.Number.PackageFee * (10 ** settings.getBasePrecision('1')),

        creator: userId,
        side: 1,
        money_id: parseInt(self.moneyId),
        stock_id: parseInt(self.stockId),
        order_type: orderType,
        custom_no_btt_fee_rate: Config.custom_no_btt_fee_rate,
        // custom_btt_fee_rate: 10,
        market_name: self.selectedMarket,
        amount: amount.toFixed(0),
        price: self.selectedTab === 'marketOrder' ?
            0 : price.toFixed(0),
        now: Math.ceil(Date.now() / 1000),
        expiration: Math.ceil(Date.now() / 1000) + 10,
        use_btt_as_fee: useBttAsFee,
        freeze_btt_fee: useBttAsFee ? fee.toString() : 0,
    };
    const currindex = self.$store.state.currAccountIndex;
    const accountInfo = self.$store.state.accountList[currindex];
    const method = 'blockchain.put_transaction';
    createOrders(
        ob,
        method,
        pk,
        accountInfo,
        self.$store.getters.currAccount.address,
    ).then((res) => {
        if (res.code !== 0) {
            return self.$Message.error(self.$t(res.errmsg));
        }
        return self.$Message.success(self.$t('trade_order_submitted'));
    });
}

export default {
    getOrderList,
    createOrders,
    cancelOrders,
    buyOrder,
    sellOrder,
};



// WEBPACK FOOTER //
// ./src/utils/orders.js